var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73242 15.6001H5.73242V9.6001H11.7324V15.6001H14.7324V6.6001L8.73242 2.1001L2.73242 6.6001V15.6001ZM2.73242 17.6001C2.18242 17.6001 1.71176 17.4044 1.32042 17.0131C0.928422 16.6211 0.732422 16.1501 0.732422 15.6001V6.6001C0.732422 6.28343 0.803422 5.98343 0.945422 5.7001C1.08676 5.41676 1.28242 5.18343 1.53242 5.0001L7.53242 0.500098C7.71576 0.366764 7.90742 0.266764 8.10742 0.200098C8.30742 0.133431 8.51576 0.100098 8.73242 0.100098C8.94909 0.100098 9.15742 0.133431 9.35742 0.200098C9.55742 0.266764 9.74909 0.366764 9.93242 0.500098L15.9324 5.0001C16.1824 5.18343 16.3784 5.41676 16.5204 5.7001C16.6618 5.98343 16.7324 6.28343 16.7324 6.6001V15.6001C16.7324 16.1501 16.5368 16.6211 16.1454 17.0131C15.7534 17.4044 15.2824 17.6001 14.7324 17.6001H9.73242V11.6001H7.73242V17.6001H2.73242Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.049b4222.svg";
export { ForwardRef as ReactComponent };